//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MatchAverageIcon from 'assets/svg/match-average-icon.svg'
import handleErrorMixin from '@/mixins/handleErrorMixin'

export default {
  name: 'MatchMax',
  components: {
    MatchAverageIcon,
  },
  mixins: [handleErrorMixin],
  props: {
    projectId: {
      type: Number,
      required: true,
    },
    occupationId: {
      type: Number,
      default: 0,
    },
  },
  async fetch() {
    await this.fetchData()
  },
  data() {
    return {
      data: {
        itemPercentage: 0,
        itemLabel: '',
      },
    }
  },
  watch: {
    occupationId: {
      handler() {
        this.fetchData()
      },
    },
    projectId: {
      handler() {
        this.fetchData()
      },
    },
  },
  methods: {
    async fetchData() {
      try {
        const response = await this.$repository.project.getMatchMax(
          this.projectId,
          this.occupationId
        )
        this.data.itemPercentage = response.max_match
        this.data.itemLabel = `${response.names} ${response.lastnames}`
      } catch (error) {
        this.handleError(
          error,
          this.$t('projects.detail.matchPotential.maxMatch.errorMessage')
        )
      }
    },
  },
}
